import { useState } from "react";
import {
  Box,
  Button,
  Stack,
  TextField,
  Typography,
  Alert,
  CircularProgress,
} from "@mui/material";
import aiBackendApi from "../../config/aiBackendAxios";

interface SampleResponseData {
  echo: string;
  fixed_message: string;
}

interface SampleResponse {
  status: number;
  message: string;
  data: SampleResponseData;
}

const AISamplePage = () => {
  const [message, setMessage] = useState("hello");
  const [response, setResponse] = useState<SampleResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    setResponse(null);
    try {
      const res = await aiBackendApi.post<SampleResponse>("/api/v1/sample", {
        message,
      });
      setResponse(res.data);
    } catch (err: unknown) {
      const e = err as { response?: { status?: number }; message?: string };
      setError(
        `Error: ${e.response?.status ?? "unknown"} ${e.message ?? ""}`.trim()
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 800 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        AI Sample (動作確認用)
      </Typography>
      <Typography variant="body2" sx={{ mb: 3, color: "text.secondary" }}>
        ai-backend のダミーエンドポイントに JWT 付きで直接リクエストを送るサンプル。
      </Typography>

      <Stack spacing={2}>
        <TextField
          label="message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          fullWidth
        />
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading || message.length === 0}
        >
          {loading ? <CircularProgress size={20} /> : "Send"}
        </Button>

        {error && <Alert severity="error">{error}</Alert>}
        {response && (
          <Alert severity="success">
            <pre style={{ margin: 0 }}>
              {JSON.stringify(response, null, 2)}
            </pre>
          </Alert>
        )}
      </Stack>
    </Box>
  );
};

export default AISamplePage;
